import { mapMutations, mapState } from "vuex"

export const base = params => {
  return {
    data () {
      return {
      }
    },
    props: ['formData'],
    mounted () {
      let fields = this.$refs["ruleForm"].fields;
      let arr = this.$parent.$parent.recodeModel[params]=[];
      for (let elem of fields.values()) {
        arr.push(elem.prop);
      }
    },
    computed: {
      ...mapState(["LANGUAGE"])
    },
    methods: {
      
    },
    watch: {}
  }
}



// WEBPACK FOOTER //
// ./src/assets/mixin/base.js